export const addOne = (num: number) => {
    return (num + 1);
}

export default addOne;